export const modes_mixin = {
  data() {
    return {
      modes: [
        {
          id: 'nochange',
          text: 'Без изменений',
          params: {
            has_metronome: {
              desc: 'Есть метроном',
              type: 'boolean',
              value: false
            },
            metronome_speed: {
              desc: 'Скорость метронома',
              type: 'range',
              min: 10,
              max: 300,
              step: 10,
              value: 60
            }
          }
        },
        {
          id: 'anagrammes',
          text: 'Анаграммы'
        },
        {
          id: 'mix_words',
          text: 'Перемешать слова'
        },
        {
          id: 'words_reverse',
          text: 'Слова с конца'
        },
        {
          id: 'sentence_reverse',
          text: 'Предложения с конца'
        },
        {
          id: 'novowels',
          text: 'Убрать гласные'
        },
        {
          id: 'skipvowels',
          text: 'Пропустить гласные'
        },
        {
          id: 'change_letters',
          text: 'Замена букв',
          params: {
            changes: {
              desc: 'Выберите буквы для замены',
              type: 'array',
              array_params: ['letter', 'change'],
              values: [],
              qnt: 0
            },
          }
        },
        {
          id: 'skip_words',
          text: 'Пропустить буквы',
          params: {
            freq: {
              desc: 'Частота',
              type: 'range',
              min: 0,
              max: 100,
              step: 1,
              value: 20
            },
          }
        },
        {
          id: 'rand_spaces',
          text: 'Случайные пробелы'
        },
        {
          id: 'striked',
          text: 'Зачеркнутый текст'
        },
        {
          id: 'randcase',
          text: 'Случайный регистр'
        },
        {
          id: 'nospaces',
          text: 'Без пробелов'
        },
        {
          id: 'translit',
          text: 'Транслит'
        },
        {
          id: 'code',
          text: 'Кодировка'
        },
        {
          id: 'rotate',
          text: 'Перевернутый'
        },
        {
          id: 'curtain',
          text: 'Шторка',
          params: {
            height: {
              desc: 'Высота шторки',
              type: 'range',
              min: 0,
              max: 100,
              step: 1,
              value: 50
            },
            offset: {
              desc: 'Смещение шторки',
              type: 'range',
              min: 0,
              max: 100,
              step: 1,
              value: 0
            }
          }
        },
        {
          id: 'disappearing_text',
          text: 'Исчезающий текст',
          params: {
            speed: {
              desc: 'Скорость',
              type: 'range',
              min: 0.05,
              max: 5,
              step: 0.05,
              value: 1
            }
          }
        },
      ],
    }
  },
};